import { FormBase } from 'core/components';

export default class DateRangeInputForm extends FormBase {
    constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				'dateRangeStart',
				'dateRangeEnd',
			],
			labels: {
				dateRangeStart: 'FILTER.DATESTART',
				dateRangeEnd: 'FILTER.DATEEND',
			},
		};
	}
}